import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import EthereumHero from "./EthereumHero";
import WhyCEthereum from "./WhyCEthereum";
import XeerEthereum from "./XeerEthereum";
import BenefitsOFEthereum from "./BenefitsOFEthereum";

function Ethereum() {
  return (
    <div>
      <Header />
      <EthereumHero />
      <WhyCEthereum />
      <XeerEthereum />
      <BenefitsOFEthereum />
      <Footer />
    </div>
  );
}

export default Ethereum;
